module.exports = __webpack_public_path__ + "img/icon.33685a5.png";